import styled from 'styled-components';
import { Loader } from '@mews-commander/ui';
import { useProductCheckListStatisticsQuery } from '../../queries/productCheckListStatisticsQuery';
import { useProductCheckListFiltersContext } from '../../contexts/ProductCheckListFiltersContext';
import { AgeCategoriesContextProvider } from '../../contexts/AgeCategoriesContext';
import { ProductCheckListStatisticsBody } from './ProductCheckListStatisticsBody';

export const ProductCheckListStatistics: React.FC = () => {
    const { filters } = useProductCheckListFiltersContext();

    const { data, isFetching } = useProductCheckListStatisticsQuery(filters);

    if (isFetching) {
        return (
            <SC.LoaderWrapper>
                <Loader />
            </SC.LoaderWrapper>
        );
    }

    if (!data) {
        return null;
    }

    return (
        <AgeCategoriesContextProvider ageCategories={data.ageCategories}>
            <ProductCheckListStatisticsBody data={data} />
        </AgeCategoriesContextProvider>
    );
};

const SC = {
    LoaderWrapper: styled.div`
        height: 127px;
    `,
};
